import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Head } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import { Link } from '@inertiajs/inertia-vue3';
import Layout from '@/Shared/Layout';
export default {
  components: {
    Head: Head,
    Icon: Icon,
    Link: Link
  },
  layout: Layout,
  props: {
    companyData: {
      type: Object,
      "default": {}
    }
  },
  data: function data() {
    return {
      parameter: "industry"
    };
  },
  methods: {
    downloadSheet: function downloadSheet() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, resData, url, link;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$store.loading = true;
                _context.prev = 1;
                _this.$store.loadingText = 'Downloading File Please Wait ...';
                _context.next = 5;
                return axios.post('/company/download_stat', {
                  "parameter": _this.parameter
                }, {
                  responseType: 'blob'
                });
              case 5:
                res = _context.sent;
                resData = res.data;
                url = window.URL.createObjectURL(new Blob([resData]));
                link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'company_data_' + _this.parameter + '_segmentation_report.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                _context.next = 19;
                break;
              case 16:
                _context.prev = 16;
                _context.t0 = _context["catch"](1);
                res = _context.t0.response;
              case 19:
                _context.prev = 19;
                _this.$store.loading = false;
                return _context.finish(19);
              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 16, 19, 22]]);
      }))();
    }
  }
};